import { ClassProvider } from "@angular/core";
import { BaseRouteReuseStrategy, ActivatedRouteSnapshot as NgActivatedRouteSnapshot, RouteReuseStrategy } from "@angular/router";
import { AppRouteData } from "../models/app-route.model";

type ActivatedRouteSnapshot = Omit<NgActivatedRouteSnapshot, "data"> & { data: AppRouteData };

export const provideAppRouteReuseStrategy = (): ClassProvider => ({
  provide: RouteReuseStrategy,
  useClass: AppRouteReuseStrategy,
});

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.data?.onSameUrlNavigation === "reload") {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}
